import React from "react";

const ListFilters = ({ children }) => {
  return <div className="columns">{children}</div>;
};

export default ListFilters;
